import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './assets/js/components/Header.js';
import Footer from './assets/js/components/Footer.js';
import BdHeader from './assets/js/components/BdHeader.js';
import BdFooter from './assets/js/components/BdFooter.js';
import CourseDetail from './assets/js/components/CourseDetail.js';
import ArticleDetail from './assets/js/components/ArticleDetail.js';
import TalkDetail from './assets/js/components/TalkDetail.js';
import ProjectDetail from './assets/js/components/ProjectDetail.js';
import PublicationDetail from './assets/js/components/PublicationDetail.js';
import Index from './assets/js/components/Index.js';
import BdIndex from './assets/js/pages/BdIndex.js';
import BdMovies from './assets/js/pages/BdMovies.js';
import BdMovieDetail from './assets/js/components/BdMovieDetail.js';
import BdSeries from './assets/js/pages/BdSeries.js';
import BdTags from './assets/js/pages/BdTags.js';
import BdFavorites from './assets/js/pages/BdFavorites.js';
import Articles from './assets/js/pages/Articles.js';
import Projects from './assets/js/pages/Projects.js';
import Publications from './assets/js/pages/Publications.js';
import Talks from './assets/js/pages/Talks.js';
import Courses from './assets/js/pages/Courses.js';
import Members from './assets/js/pages/Members.js';
import AdminPage from './assets/js/pages/AdminPage.js';
import LoginPage from './assets/js/pages/LoginPage';
import BdLoginPage from './assets/js/pages/BdLoginPage.js';
import BdAdminPage from './assets/js/pages/BdAdminPage';
import BdUserPage from './assets/js/pages/BdUserPage';
import { useAdminAuth } from './context/AdminAuthContext';

const App = () => {
    const { isLoggedIn, setIsLoggedIn, isAdmin, setIsAdmin } = useAdminAuth(); 
    const location = useLocation();

    useEffect(() => {
        const storedLoggedIn = localStorage.getItem('loggedIn') === 'true';
        const storedRole = localStorage.getItem('role') || 'user';
        setIsLoggedIn(storedLoggedIn);
        setIsAdmin(storedRole === 'admin');
    }, [setIsLoggedIn, setIsAdmin]);

    const isBdRoute = location.pathname.startsWith('/ligaincom/bd');

    return (
        <>
            {isBdRoute ? <BdHeader /> : <Header />}
            <main>
                <Routes>
                    <Route path="/ligaincom/integrantes" element={<Members />} />
                    <Route 
                        path="/ligaincom/admin" 
                        element={isAdmin ? <AdminPage /> : <LoginPage />} 
                    />
                    <Route
                        path="/ligaincom/bd/login"
                        element={
                          isLoggedIn
                            ? (isAdmin ? <BdAdminPage /> : <BdUserPage />)
                            : <BdLoginPage />
                        }
                    />
                    <Route path="/ligaincom/congresos_seminarios" element={<Talks />} />
                    <Route path="/ligaincom/cursos" element={<Courses />} />
                    <Route path="/ligaincom/publicaciones" element={<Publications />} />
                    <Route path="/ligaincom/proyectos" element={<Projects />} />
                    <Route path="/ligaincom/divulgacion" element={<Articles />} />
                    <Route path="/ligaincom/detalles/curso/:idcourse" element={<CourseDetail />} />
                    <Route path="/ligaincom/detalles/articulo/:idarticle" element={<ArticleDetail />} />
                    <Route path="/ligaincom/detalles/congreso/:idtalk" element={<TalkDetail />} />
                    <Route path="/ligaincom/detalles/proyecto/:idproject" element={<ProjectDetail />} />
                    <Route path="/ligaincom/detalles/publicacion/:idpublication" element={<PublicationDetail />} />
                    <Route path="/ligaincom" element={<Index />} />
                    <Route path="/ligaincom/bd" element={<BdIndex />} />
                    <Route path="/ligaincom/bd/peliculas" element={<BdMovies />} />
                    <Route path="/ligaincom/bd/series" element={<BdSeries />} />
                    <Route path="/ligaincom/bd/etiquetas" element={<BdTags />} />
                    <Route path="/ligaincom/bd/favoritos" element={<BdFavorites />} />
                    <Route path="/ligaincom/bd/login" element={<BdLoginPage />} />
                    <Route path="/ligaincom/bd/detalles/pelicula/:idMovie" element={<BdMovieDetail />} />
                    <Route path="/" element={<Index />} />
                </Routes>
            </main>
            {isBdRoute ? <BdFooter /> : <Footer />}
        </>
    );
};

export default App;
